module.exports = __webpack_public_path__ + "img/adulto18.a32e0ddc.jpg";